import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { getQueryStringValueByParameter } from '../helpers'
import { connect } from 'react-redux'
import { fetchUserByOpportunityId } from '../actions/userActions'
import { loginPageRequest } from '../actions/authenticationActions'
import { updateAccount, updateToken } from '../actions/updateActions'
import { msalApp, tokenRequest } from '../utils/authConfig'
import { receiveConsultantLoginSuccess } from '../actions/authenticationActions'
import { updateForProposalViewFromEmail } from 'actions/emailActions'
import { Icon } from 'icons'

class Consultant extends React.Component {
  state = {
    isOpportunityIDProvided: false,
    isOpportunityIDValid: true,
    isAuthenticated: false,
    opportunityId: null,
  }

  componentDidMount() {
    this.props.dispatch(loginPageRequest())
    var url = window.location.href.toLowerCase()
    if (url.indexOf('?oppid=') !== -1) {
      let oppId = getQueryStringValueByParameter('oppid', url)
      this.props.dispatch(fetchUserByOpportunityId(oppId))
      this.setState({
        isOpportunityIDProvided: true,
        opportunityId: oppId,
      })
    }

    if (url.indexOf('&viewproposal=true') !== -1) {
      this.props.dispatch(updateForProposalViewFromEmail())
    }
  }

  handleSignIn = () => {
    if (this.props.user.email !== null) {
      this.setState({
        isOpportunityIDValid: true,
      })
      this.props.onSignIn().then(() => {
        msalApp
          .acquireTokenSilent(tokenRequest)
          .then((response) => {
            this.props.dispatch(updateToken(response.accessToken))

            if (this.props.account) {
              this.props.dispatch(updateAccount(this.props.account))
              this.props.dispatch(
                receiveConsultantLoginSuccess(this.state.opportunityId)
              )
              this.props.history.push(
                this.props.user.isAtSettlement
                  ? '/consultant/settlements'
                  : '/consultant/home'
              )
            } else {
              if (this.props.error) {
                this.props.updateError(this.props.error)
              } else {
                this.props.updateError({
                  errorMessage: 'Sign-in failed. Please try again.',
                })
              }
            }
          })
          .catch((error) => {
            // Call acquireTokenPopup (popup window) in case of acquireTokenSilent failure
            // due to consent or interaction required ONLY
            /*if (requiresInteraction(error.errorCode)) {
                        return useRedirectFlow
                            ? msalApp.acquireTokenRedirect(tokenRequest)
                            : msalApp.acquireTokenPopup(tokenRequest);
                    } else {
                        console.error('Non-interactive error:', error.errorCode)
                    }*/
          })
      })
    } else {
      this.setState({
        isOpportunityIDValid: false,
      })
    }
  }

  handleSignOut = () => {
    this.props.onSignOut().then(() => {
      if (!this.props.account) {
        this.props.updateAccount(null)
        this.props.dispatch(updateAccount(null))
      } else {
        if (this.props.error) {
          this.props.updateError(this.props.error)
        } else {
          this.props.updateError({
            errorMessage: 'Sign-out failed. Please try again.',
          })
        }
      }
    })
  }

  render() {
    return (
      <div id="page">
        <div className="oly-container">
          <div className="oly-image-container">
            <Icon iconType="OlyLogo" size={2} />
            <Container className="login-container p-5 mb-5 shadow-sm container" style={{backgroundColor:"#F2EDE8"}}>
              {this.state.isOpportunityIDProvided && (
                <>
                  <div className="text-center mt-3 mb-3">
                    <h2 className="text-dark">
                      Welcome to the Digital Estimate Portal
                    </h2>
                    <br />
                    <div>
                      To access your Oly customer’s estimate(s), please login using
                      your McMillan Shakespeare credentials below.
                    </div>
                  </div>
                  
                  <div className="text-center mt-3 mb-3">
                    <div>
                      {this.props.user.email && (
                        <img
                          className="mt-3 clickable btn-consultant"
                          onClick={this.handleSignIn}
                          src="../../images/icon-btn-consultant.png"
                          alt=""
                        />
                      )}
                      {!this.props.user.email && (
                        <img
                          className="mt-3 clickable btn-consultant readonly"
                          src="../../images/icon-btn-consultant.png"
                          alt=""
                        />
                      )}
                    </div>
                    <span><img src="./../images/steve.png" alt="" style={{maxHeight: '160px', marginTop: '18px' }}/> </span>
                  </div>
                </>
              )}

              {!this.state.isOpportunityIDValid && (
                <div className="text-center mt-3 mb-3 text-danger">
                  Please enter a valid opportunity ID
                </div>
              )}

              {!this.state.isOpportunityIDProvided && (
                <div className="text-center mt-3 mb-3 text-danger">
                  Opportunity ID is not provided
                </div>
              )}
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

Consultant.propTypes = {
  account: PropTypes.object,
  error: PropTypes.string,
  onSignIn: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    user: state.user,
    auth: state.auth,
  }
}

export default connect(mapStateToProps)(Consultant)
